import styled from 'styled-components';

export const DevelopmentBlock = styled.div`
  padding: 0;

  div[class*='SectionHeadlinestyled__SectionHeadline-'] {
    margin-bottom: 0;
  }

  .home_link {
  }
`;
